import { render, staticRenderFns } from "./ContratacaoNatureza.vue?vue&type=template&id=6975992c"
import script from "./ContratacaoNatureza.vue?vue&type=script&lang=js"
export * from "./ContratacaoNatureza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports